import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddLoginComponent } from './add-login.component';

const routes: Routes = [
    {
        path: '',
        component: AddLoginComponent,
        data: {
            title: 'Add Login'
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AddLoginRoutingModule { 

    
}
